import type { ReactNode } from "react";

import { twMerge } from "tailwind-merge";

type AssetSectionProps = {
  children: ReactNode;
  count: number;
  /** Highlighted (purple) header — used for the "all variations" section. */
  highlight?: boolean;
  icon: ReactNode;
  subtitle: string;
  title: string;
};

export function AssetSection({
  children,
  count,
  highlight = false,
  icon,
  subtitle,
  title,
}: AssetSectionProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-border-secondary">
      <div
        className={twMerge(
          "flex items-center justify-between gap-md border-b border-border-secondary px-lg py-md",
          highlight && "border-utility-brand-100 bg-utility-brand-50",
        )}
      >
        <div className="flex items-center gap-md">
          <span
            className={twMerge(
              "flex size-9 shrink-0 items-center justify-center rounded-lg",
              highlight
                ? "bg-bg-brand-solid text-fg-white"
                : "border border-border-secondary bg-bg-primary text-text-secondary",
            )}
          >
            {icon}
          </span>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-text-primary">
              {title}
            </span>
            <span className="text-xs text-text-tertiary">{subtitle}</span>
          </div>
        </div>

        <span className="shrink-0 rounded-full border border-utility-brand-200 bg-bg-primary px-md py-xxs text-xs font-medium text-fg-brand-primary">
          {count} assets
        </span>
      </div>

      <div className="p-lg">{children}</div>
    </div>
  );
}
